import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CartPrice } from '../../../../projects/shared-lib/src/lib/models/cart-price';
import { CurrencyPipe, NgStyle, NgClass } from '@angular/common';
import { TemplateQtyComponent } from '../template-qty/template-qty.component';
import { PriceLevels } from '../../../../projects/shared-lib/src/lib/models/price-levels';
import { ItemHour } from '../../../../projects/shared-lib/src/lib/models/item-hour';
import { MatDivider } from '@angular/material/divider';
import { PriceWeb } from '../../../../projects/shared-lib/src/lib/models/price-web';
import { TranslateLangPipe } from '../../../../projects/shared-lib/src/lib/pipe/translate-lang.pipe';
import { LibDimOnDirective } from '../../../../projects/shared-lib/src/lib/directives/lib-dim-on.directive';

@Component({
    selector: 'tw-template-price',
    imports: [MatTooltip, CurrencyPipe,
    TranslateModule, NgStyle, MatDivider,
    TemplateQtyComponent, TranslateLangPipe,
    LibDimOnDirective, NgClass],
    templateUrl: './template-price.component.html',
    styleUrl: './template-price.component.scss',
})
export class TemplatePriceComponent implements OnInit, OnChanges, OnDestroy {
    @Input() stylePrice: 'onlyPrice' | 'priceAndLevel' | 'priceAndLevel2' = 'priceAndLevel';
    @Input() priceLevel: PriceLevels;
    @Input() price: CartPrice | PriceWeb | any;
    @Input() itemHour: ItemHour;
    @Input() showQty: any;
    @Input() useTemplateQty = false;
    @Input() showTotal = true;
    @Input() maxQty = -1;
    @Input() minQty = -1;
    @Input() validateMaxTickets = false;

    serviceCharge_min: number;
    serviceCharge_max: number;
    showPriceLevelAndPrice = false;

    prices: CartPrice[];
    soldout: any;
    price_min: number;
    hasPromo = false;
    rs = false;
    price_max: number;
    original_price_min: number;
    original_price_max: number;

    constructor(public translate: TranslateService) {}

    getPageId() {
        return '';
    }

    ngOnDestroy(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['priceLevel'] || changes['price']) {
            this.initData();
        }
    }

    ngOnInit(): void {
        this.initData();
    }

    private initData(): void {
        if (this.priceLevel) {
            if (this.priceLevel.prices) {
                this.prices = this.priceLevel.prices;
            }
            this.serviceCharge_min = this.priceLevel.serviceCharge_min;
            this.serviceCharge_max = this.priceLevel.serviceCharge_max;
            this.price_min = this.priceLevel.price_min;
            this.price_max = this.priceLevel.price_max;
            this.original_price_min = this.priceLevel.original_price_min;
            this.original_price_max = this.priceLevel.original_price_max;
            if (this.priceLevel.prices.length > 1 || this.itemHour?.priceLevels.length > 1) {
                this.showPriceLevelAndPrice = true;
            }

            this.hasPromo = this.priceLevel.hasPromo;
            this.rs = this.priceLevel.rs;
            //  this.prices[0].originalPrice = 1000;
             this.soldout = this.priceLevel.soldout;
            // this.hasPromo =  true;
        }
        if (this.itemHour?.priceLevels.length > 0) {
            this.showPriceLevelAndPrice = true;
        }
        if (this.price) {
            this.prices = [this.price];
            this.serviceCharge_min = this.price.serviceCharges;
            this.serviceCharge_max = this.price.serviceCharges;
            this.price_min = this.price.price;
            this.price_max = this.price.price;
            this.soldout = this.price.soldout;
            this.hasPromo = !!this.price.promoId;
            this.rs = this.price.rs;
        }
    }

    protected readonly Object = Object;
}
